export const resume = {
    experience: [
      {
        title: "Web Developer : ",
        subTitle: "Abhyaz",
        description:
          "At Abhyaz, I enhanced SEO and developed a CMS website.",
          date: "June 2023 - July 2023",
      },
      {
        title: "Software Developer Intern : ",
        subTitle: "Astarix",
        description:
          "At Astarix, I maintained the codebase and developed webAR-based solutions.",
          date: "December 2023 - June 2024",

      },
      
      
    ],
    education: [
      {
        title: "Secondary :",
        subTitle: "Bishop Johnson School",
        description:
          "10th Grade : 81%",
      },
      {
        title: "Higher Secondary :",
        subTitle: "Bishop Johnson School",
        description:
          "12th Grade : 89%",
      },
      {
        title: "B.Tech : ",
        subTitle: "Jaypee University of Engineering Guna",
        description:
          "Bachelor of technology in computer science",
      },
    ],
  };